import {
  ABNEGATIVE,
  ABPOSITIVE,
  ACCEPTED,
  ACCOUNTANTS,
  ACTIVATED,
  ANEGATIVE,
  APOSITIVE,
  APPROXIMATETAXES_COMPLETE,
  APPROXIMATETAXES_SIMPLIFIED,
  BALANCEWALLETS,
  BANKCHECK,
  BANKDEPOSIT,
  BANKTRANSFER,
  BILLETBANK,
  BNEGATIVE,
  BPOSITIVE,
  CANCELED,
  CANCELLATION_REQUESTED,
  CASH,
  CREATED,
  CREDITCARD,
  DEBITCARD,
  DIRECTDEBIT,
  ELECTRONICTRANSFER,
  EXPIRED,
  IGNORED,
  INITIALBALANCE,
  INTRIAL,
  MUNICIPAL,
  NATIONAL,
  ONEGATIVE,
  OPOSITIVE,
  OTHER,
  PAYMENT,
  PAYPAL,
  PENDING,
  PIX,
  PROFILE_ACCOUNTANT,
  PROFILE_ADMINISTRADOR,
  PROFILE_DOCTOR,
  PROFILE_FINANCIAL,
  PROFILE_OTHER,
  PROFILE_PARTNERSHIP,
  PROFILE_RECEPTIONIST,
  PROFILE_STUDENT,
  PROFILE_USER,
  RECEIPT,
  RECONCILED,
  ROLE_ACCOUNTANT,
  ROLE_ADMIN,
  ROLE_CLINIC_ADMINISTRATOR,
  ROLE_FINANCIAL,
  ROLE_OTHER_HEALTH_PROFESSIONAL,
  ROLE_PARTNERSHIP,
  ROLE_PROFESSIONAL,
  ROLE_RECEPTIONIST,
  ROLE_STUDENT,
  STATE,
  SUSPENDED,
  INACTIVATED,
  ROLE_FINANCIAL_ADMINISTRATOR,
  PROFILE_FINANCIAL_ADMINISTRATOR,
  ROLE_STOCK,
  OUTGOING,
  INCOMING,
  CONCLUDED,
  INPROGRESS,
  AVAILABLE
} from './types';

const display = {
  [CREATED]: 'Aguardando pagamento',
  [ACTIVATED]: 'Ativo',
  [INACTIVATED]: 'Inativo',
  [CANCELED]: 'Cancelado',
  [SUSPENDED]: 'Suspensa',
  [EXPIRED]: 'Vencida',
  [INTRIAL]: 'Em período de teste',
  [PENDING]: 'Pendente',
  [IGNORED]: 'Ignorado',
  [RECONCILED]: 'Conciliado',
  [ACCEPTED]: 'Aceito',
  [RECEIPT]: 'Receita',
  [PAYMENT]: 'Despesa',
  [INITIALBALANCE]: 'Saldo inicial',
  [BILLETBANK]: 'Boleto',
  [CREDITCARD]: 'Cartão de crédito',
  [DEBITCARD]: 'Cartão de débito',
  [PAYPAL]: 'PayPal',
  [CASH]: 'Dinheiro',
  [BANKDEPOSIT]: 'Depósito bancário',
  [BANKTRANSFER]: 'TED / DOC',
  [BALANCEWALLETS]: 'Saldo na Carteira',
  [ELECTRONICTRANSFER]: 'Transferência eletrônica',
  [BANKCHECK]: 'Cheque',
  [PIX]: 'Pix',
  [OTHER]: 'Outra',
  [DIRECTDEBIT]: 'Débito em conta',
  [AVAILABLE]: 'Em aberto',
  [INCOMING]: 'Entrada',
  [OUTGOING]: 'Saída',

  [APPROXIMATETAXES_COMPLETE]: 'Completo',
  [APPROXIMATETAXES_SIMPLIFIED]: 'Simplificado',
  [CANCELLATION_REQUESTED]: 'Cancelamento solicitado',
  [NATIONAL]: 'Nacional',
  [STATE]: 'Estadual',
  [MUNICIPAL]: 'Municipal',
  [ACCOUNTANTS]: 'Contadores',
  BLOOD: {
    [APOSITIVE]: 'A+',
    [ANEGATIVE]: 'A-',
    [BPOSITIVE]: 'B+',
    [BNEGATIVE]: 'B-',
    [ABPOSITIVE]: 'AB+',
    [ABNEGATIVE]: 'AB-',
    [OPOSITIVE]: 'O+',
    [ONEGATIVE]: 'O'
  },
  WEEKDAYS: {
    sunday: 'Dom',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sáb'
  },
  USERTENANT_INVITATION_STATUS: {
    [PENDING]: 'Pendente',
    [ACCEPTED]: 'Ativo'
  },
  ROLES: {
    [ROLE_ADMIN]: 'Administrador',
    [ROLE_CLINIC_ADMINISTRATOR]: 'Administrador',
    [ROLE_PROFESSIONAL]: 'Médico',
    [ROLE_RECEPTIONIST]: 'Recepcionista',
    [ROLE_OTHER_HEALTH_PROFESSIONAL]: 'Profissional da saúde',
    [ROLE_STUDENT]: 'Estudante',
    [ROLE_FINANCIAL]: 'Financeiro',
    [ROLE_ACCOUNTANT]: 'Contador',
    [ROLE_PARTNERSHIP]: 'Parceiro',
    [ROLE_FINANCIAL_ADMINISTRATOR]: 'Adminstrador BPO',
    [ROLE_STOCK]: 'Estoque'
  },
  PROFILES: {
    [PROFILE_DOCTOR]: 'Médico',
    [PROFILE_ADMINISTRADOR]: 'Administrador',
    [PROFILE_OTHER]: 'Profissional da saúde',
    [PROFILE_RECEPTIONIST]: 'Recepcionista',
    [PROFILE_ACCOUNTANT]: 'Contador',
    [PROFILE_FINANCIAL]: 'Financeiro',
    [PROFILE_STUDENT]: 'Estudante',
    [PROFILE_USER]: 'Usuário',
    [PROFILE_PARTNERSHIP]: 'Parceiro(a)',
    [PROFILE_FINANCIAL_ADMINISTRATOR]: 'Adminstrador BPO'
  },
  PAYMENTMETHOD: {
    [CREDITCARD]: 'Cartão de crédito',
    [BILLETBANK]: 'Boleto',
    [PIX]: 'Pix'
  },
  PATIENTPROCEDURESUITE: {
    [ACTIVATED]: 'Em aberto',
    [CONCLUDED]: 'Finalizado',
    [INACTIVATED]: 'Cancelado'
  },
  [CONCLUDED]: 'Concluído',
  [INPROGRESS]: 'Em progresso'
};

export default display;
